import { render, staticRenderFns } from "./TaskRequestEditDialog.vue?vue&type=template&id=7bc2ed3a"
import script from "./TaskRequestEditDialog.vue?vue&type=script&lang=js"
export * from "./TaskRequestEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports